import {Outlet} from '@github-ui/react-router'
import {LayoutComponent} from '../App'
import {pullRequestsLayoutRoute} from './layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRespondToRouteChange} from '../hooks/use-respond-to-route-change'
import {useCallback} from 'react'

export function LayoutEntrypoint() {
  const {
    data: {pullRequest, bannersData, repository, urls, user, aliveChannel, pageTitle},
  } = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  const {refetch: refetchTabCounts} = useRouteQuery(pullRequestsLayoutRoute, 'tabCounts')
  const {refetch: refetchDiffstat} = useRouteQuery(pullRequestsLayoutRoute, 'diffstat')

  // Refetch shared data when the route changes to keep diffstat and tab counts up to date
  // this is preferred over git_updated live updates to reduce the number of requests made
  const handleRouteChange = useCallback(() => {
    refetchTabCounts()
    refetchDiffstat()
  }, [refetchTabCounts, refetchDiffstat])

  useRespondToRouteChange(handleRouteChange)

  return (
    <LayoutComponent
      aliveChannel={aliveChannel}
      pullRequest={pullRequest}
      bannersData={bannersData}
      repository={repository}
      pageTitle={pageTitle}
      urls={urls}
      user={user}
    >
      <Outlet />
    </LayoutComponent>
  )
}

try{ LayoutEntrypoint.displayName ||= 'LayoutEntrypoint' } catch {}